import { Tenant } from "../features/tenant";
import { useParams } from "react-router-dom";

export const TenantPage = () => {
  const prms = useParams();
  const subscriptionId = prms.subscriptionId ?? "";
  const tenantId = prms.tenantId ?? "";
  return <Tenant tenantId={tenantId} subscriptionId={subscriptionId} />;
};
